import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { GLASS, PHI, TYPE, GLOW } from "@/lib/glass";

export default function NotFound() {
  return (
    <section
      data-testid="not-found"
      className="flex min-h-screen flex-col items-center justify-center text-center"
      style={{ paddingLeft: PHI.s3, paddingRight: PHI.s3 }}
    >
      <motion.span
        aria-hidden="true"
        initial={{ opacity: 0, scaleX: 0.3 }}
        animate={{ opacity: 1, scaleX: 1 }}
        transition={{ duration: 1.5, ease: GLASS.settle }}
        className="gold-hairline"
      />
      <motion.h1
        data-testid="not-found-line"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.3, delay: 0.3, ease: GLASS.settle }}
        style={{ marginTop: PHI.s3, fontSize: TYPE.lead, letterSpacing: "0.04em", textShadow: GLOW.silverSoft }}
        className="font-light text-[#F5F5F7]"
      >
        This room has not been lit yet.
      </motion.h1>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.4, delay: 1.0, ease: GLASS.settle }}
        style={{ marginTop: PHI.s4 }}
      >
        <Link
          to="/"
          data-testid="not-found-return"
          className="inline-flex min-h-[44px] items-center font-light text-[#84DFF4] transition-colors duration-500 hover:text-[#F5F5F7]"
          style={{ fontSize: TYPE.body, letterSpacing: "0.06em" }}
        >
          Return to the threshold
        </Link>
      </motion.div>
    </section>
  );
}
